import { Commitment, Invoice } from 'dashboard/models/invoice';
import Action from 'lib/interfaces/Action';

export type CurrentInvoiceActions = Action<
  CurrentInvoiceActionType.SetCurrentInvoice,
  SetCurrentInvoicePayload
>;

export enum CurrentInvoiceActionType {
  SetCurrentInvoice = 'invoices/SET_CURRENT_INVOICE',
}

interface SetCurrentInvoicePayload {
  currentInvoice: Invoice;
  commitments: Commitment[];
}

export function setCurrentInvoice(
  currentInvoice: Invoice,
  commitments: Commitment[],
): Action<CurrentInvoiceActionType.SetCurrentInvoice, SetCurrentInvoicePayload> {
  return {
    payload: {
      currentInvoice,
      commitments,
    },
    type: CurrentInvoiceActionType.SetCurrentInvoice,
  };
}
